export type ChartPopupItemId = string;
export type ChartDataId = string;
export type ComposedId = `${ChartDataId}::${ChartPopupItemId}`;

/**
 * 차트 팝업 드롭다운의 각 항목을 표현.
 * 위젯에 따라 실제 의미가 다름: 1개의 target(byTarget), metric(byStat),
 * displayName(Pie/TopList) 등.
 *
 * 표시용 메타만 보유. 각 위젯의 click/popup navigation 에서 필요한
 * TriggerDetailInfo 는 composable 에 주입된 resolver 로 lazy 조회한다.
 */
export type ChartPopupItem = {
  id: ChartPopupItemId;
  name: string;
  /** 표시 전용 alias. 비어있거나 trim 후 빈 값이면 표시 시점에 name으로 fallback. id/매칭용 X. */
  alias?: string;
  color?: string;
  icon?: string;
  value?: number | null;
  unit?: string;
  formattedValue?: string;
  label?: number | null;
};

export type ChartPopupItemEntry = {
  composedId: ComposedId;
  popupItem: ChartPopupItem;
};

export const toComposedId = (chartDataId: string, popupItemId: string): ComposedId =>
  `${chartDataId}::${popupItemId}`;
